export default "__VITE_ASSET__CXVjUppb__"